import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MAPBOX_STYLE_TILE } from '../../../features/predictionMap/constants/mapbox';
import { latlngType } from '../../../features/predictionMap/types';
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import currentIcon from '../../../assets/current.png';

type onChangeMapzoomType = (zoom: number) => void;

const ChangeMapCenter = ({ center, zoomLevel }: { center: latlngType; zoomLevel: number }) => {
  const map = useMap();
  if (center) {
    map.panTo([center[0], center[1]]);
    map.setZoom(zoomLevel);
  }

  return null;
};

const ChangeMapZoomLevel = ({ onChange }: { onChange: onChangeMapzoomType }) => {
  const map = useMapEvents({
    zoomend: () => {
      onChange(map.getZoom());
    },
  });
  return null;
};

type PredictionMapProps = {
  currentMarker: [number, number];
  onChange: (latlng: latlngType) => void;
};

const BasicMap: FC<PredictionMapProps> = ({ currentMarker, onChange }) => {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const markerRef = React.useRef<L.Marker | null>(null);
  const [zoomLevel, setZoomLevel] = React.useState<number>(13);
  const eventHandlers = React.useMemo(() => {
    return {
      dragend: () => {
        const marker = markerRef.current;
        if (marker) {
          const latLng = marker.getLatLng();
          onChange([latLng.lat, latLng.lng]);
        }
      },
    };
  }, [onChange]);

  const handleChangeMapZoom = (val: number) => {
    setZoomLevel(val);
  };

  const mapStyleTile = React.useMemo(() => {
    const lang = language as 'ja' | 'en';
    return MAPBOX_STYLE_TILE[lang].default;
  }, [language]);

  const defaultIcon = L.icon({
    iconUrl: currentIcon,
    iconSize: [25, 33],
    iconAnchor: [14, 28],
  });

  return (
    <>
      <MapContainer
        center={currentMarker}
        style={{ height: '55vh', width: '100%' }}
        zoom={zoomLevel}
      >
        <TileLayer
          attribution='© <a href="https://www.mapbox.com/map-feedback/">Mapbox</a>'
          url={mapStyleTile}
          crossOrigin={'anonymous'}
        />

        <Marker
          ref={markerRef}
          position={currentMarker}
          draggable={true}
          eventHandlers={eventHandlers}
          icon={defaultIcon}
        ></Marker>
        <ChangeMapZoomLevel onChange={handleChangeMapZoom} />
        <ChangeMapCenter center={currentMarker} zoomLevel={zoomLevel} />
      </MapContainer>
    </>
  );
};

export default BasicMap;
